import { AccordionNavigation } from "twyne-new.ui";

export default function Navigation({ children, value }) {
  return <AccordionNavigation type='multiple' collapsible value={value}>
    {children}
  </AccordionNavigation>
}
